"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _dept = _interopRequireDefault(require("@/api/system/dept"));

var _vueTreeselect = _interopRequireWildcard(require("@riophae/vue-treeselect"));

require("@riophae/vue-treeselect/dist/vue-treeselect.css");

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _CRUD = _interopRequireDefault(require("@crud/CRUD.operation"));

var _UD = _interopRequireDefault(require("@crud/UD.operation"));

var _DateRangePicker = _interopRequireDefault(require("@/components/DateRangePicker"));

var _methods;

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var defaultForm = {
  id: null,
  contractPrefix: null,
  distributorPrefix: null,
  name: null,
  isTop: '1',
  subCount: 0,
  pid: null,
  deptSort: 999,
  enabled: 'true'
};
var _default = {
  name: 'Dept',
  components: {
    Treeselect: _vueTreeselect.default,
    crudOperation: _CRUD.default,
    rrOperation: _RR.default,
    udOperation: _UD.default,
    DateRangePicker: _DateRangePicker.default
  },
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '部门',
      url: 'api/dept',
      crudMethod: _objectSpread({}, _dept.default)
    });
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(defaultForm), (0, _crud.crud)()],
  // 设置数据字典
  dicts: ['dept_status'],
  data: function data() {
    return {
      depts: [],
      rules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        deptSort: [{
          required: true,
          message: '请输入序号',
          trigger: 'blur',
          type: 'number'
        }]
      },
      permission: {
        add: ['admin', 'dept:add'],
        edit: ['admin', 'dept:edit'],
        del: ['admin', 'dept:del']
      },
      enabledTypeOptions: [{
        key: 'true',
        display_name: '正常'
      }, {
        key: 'false',
        display_name: '禁用'
      }]
    };
  },
  methods: (_methods = {
    getDeptDatas: function getDeptDatas(tree, treeNode, resolve) {
      var params = {
        pid: tree.id
      };
      setTimeout(function () {
        _dept.default.getDepts(params).then(function (res) {
          resolve(res.content);
        });
      }, 100);
    }
  }, (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterToCU, function (crud, form) {
    if (form.pid !== null) {
      form.isTop = '0';
    } else if (form.id !== null) {
      form.isTop = '1';
    }

    form.enabled = "".concat(form.enabled);

    if (form.id != null) {
      this.getSupDepts(form.id);
    } else {
      this.getDepts();
    }
  }), (0, _defineProperty2.default)(_methods, "getSupDepts", function getSupDepts(id) {
    var _this = this;

    _dept.default.getDeptSuperior(id).then(function (res) {
      var date = res.content;

      _this.buildDepts(date);

      _this.depts = date;
    });
  }), (0, _defineProperty2.default)(_methods, "buildDepts", function buildDepts(depts) {
    var _this2 = this;

    depts.forEach(function (data) {
      if (data.children) {
        _this2.buildDepts(data.children);
      }

      if (data.hasChildren && !data.children) {
        data.children = null;
      }
    });
  }), (0, _defineProperty2.default)(_methods, "getDepts", function getDepts() {
    var _this3 = this;

    _dept.default.getDepts({
      enabled: true
    }).then(function (res) {
      _this3.depts = res.content.map(function (obj) {
        if (obj.hasChildren) {
          obj.children = null;
        }

        return obj;
      });
    });
  }), (0, _defineProperty2.default)(_methods, "loadDepts", function loadDepts(_ref) {
    var action = _ref.action,
        parentNode = _ref.parentNode,
        callback = _ref.callback;

    if (action === _vueTreeselect.LOAD_CHILDREN_OPTIONS) {
      _dept.default.getDepts({
        enabled: true,
        pid: parentNode.id
      }).then(function (res) {
        parentNode.children = res.content.map(function (obj) {
          if (obj.hasChildren) {
            obj.children = null;
          }

          return obj;
        });
        setTimeout(function () {
          callback();
        }, 100);
      });
    }
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterValidateCU, function () {
    if (this.form.pid !== null && this.form.pid === this.form.id) {
      this.$message({
        message: '上级部门不能为空',
        type: 'warning'
      });
      return false;
    }

    if (this.form.isTop === '1') {
      this.form.pid = null;
    }

    return true;
  }), (0, _defineProperty2.default)(_methods, "changeEnabled", function changeEnabled(data, val) {
    var _this4 = this;

    this.$confirm('此操作将 "' + this.dict.label.dept_status[val] + '" ' + data.name + '部门, 是否继续？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      _dept.default.edit(data).then(function (res) {
        _this4.crud.notify(_this4.dict.label.dept_status[val] + '成功', _crud.default.NOTIFICATION_TYPE.SUCCESS);
      }).catch(function (err) {
        data.enabled = !data.enabled;
        console.log(err.response.data.message);
      });
    }).catch(function () {
      data.enabled = !data.enabled;
    });
  }), (0, _defineProperty2.default)(_methods, "checkboxT", function checkboxT(row, rowIndex) {
    return row.id !== 1;
  }), (0, _defineProperty2.default)(_methods, "inputExcel", function inputExcel() {}), _methods)
};
exports.default = _default;